import { render, staticRenderFns } from "./MonthlyQrRegistration.vue?vue&type=template&id=5bb7cd48&scoped=true&"
import script from "./MonthlyQrRegistration.vue?vue&type=script&lang=js&"
export * from "./MonthlyQrRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb7cd48",
  null
  
)

export default component.exports